import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";
import logo from "../../images/cooktop_logo.png";
import Button from "../ui/Button";

export const NAVBAR_HEIGHT = 72;

function Navbar() {
  const { isAuthenticated, loginWithRedirect, logout } = useAuth0();

  const handleAuthClick = () => {
    if (isAuthenticated) {
      logout({ logoutParams: { returnTo: window.location.origin } });
    } else {
      loginWithRedirect();
    }
  };

  return (
    <header
      className="fixed top-0 inset-x-0 z-50 bg-[#0E0E0E]/95 backdrop-blur border-b border-white/10 shadow-[0_4px_24px_rgba(0,0,0,0.45)]"
      style={{ height: NAVBAR_HEIGHT }}
    >
      <div className="h-full max-w-screen-2xl mx-auto px-6 flex items-center justify-between">
        <img
          src={logo}
          alt="Cooktop Safety"
          className="h-10 w-auto object-contain"
        />
        <Button
          variant={isAuthenticated ? "ghost" : "primary"}
          size="sm"
          leadingIcon={
            isAuthenticated ? (
              <LogoutIcon fontSize="small" />
            ) : (
              <LoginIcon fontSize="small" />
            )
          }
          onClick={handleAuthClick}
          aria-label={isAuthenticated ? "Log out" : "Log in"}
        >
          {isAuthenticated ? "Log out" : "Log in"}
        </Button>
      </div>
    </header>
  );
}

export default Navbar;
